
























import { TweenMax } from 'gsap';
import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { personas } from '@/data';
import { IPersona } from '@/@types';
import PersonaTagsVue from '@/components/PersonaTags.vue';
import ExpandVue from '@/components/Expand.vue';
import LinkedInIconVue from '@/components/LinkedInIcon.vue';
import EmploymentTagVue from '@/components/EmploymentTag.vue';

const appModule = namespace('app');
const employmentModule = namespace('employment');
const personaModule = namespace('persona');
const cssName: string = 'filterBar';

@Component({
  components: {
    EmploymentTagVue,
    ExpandVue,
    LinkedInIconVue,
    PersonaTagsVue,
  },
})
export default class FilterBar extends Vue {
  @appModule.Action('hideFilters') public hideFilters!: () => void;
  @appModule.Action('toggleFilters') public toggleFilters!: () => void;
  @appModule.State('showFilters') public showFilters!: boolean;
  @employmentModule.State('tags') public tags!: string[];
  @personaModule.Getter('hasActivePersona') public hasActivePersona!: boolean;
  @personaModule.State('currentPersona') public currentPersona!: IPersona;

  public scrollDirection: string = '';
  public scrollPer: number = 0;
  public scrollPosition: number = 0;
  public scrolledPast: boolean = false;
  public scrolledUp: boolean = false;

  @Watch('showFilters')
  public onShowFiltersChanged(val: boolean, oldVal: boolean) {
    const db = document.body as HTMLElement;
    const dde = document.documentElement as HTMLElement;
    db.style.overflowY =
    dde.style.overflowY = val ? 'hidden' : 'auto';

    if (val) {
      document.body.addEventListener('touchmove', this.onBodyTouch, { passive: false });
    } else {
      document.body.removeEventListener('touchmove', this.onBodyTouch);
    }
  }

  public get classes(): object {
    return {
      [`${cssName}`]: true,
      [`${cssName}--scroll`]: this.scrolled || this.showFilters,
      [`${cssName}--showFilters`]: this.showFilters,
      // [`${cssName}--scroll`]: this.scrolled && this.scrollDirection === 'up',
    };
  }

  public onBodyTouch(e: Event): void {
    if (this.showFilters) {
      e.preventDefault();
    }
  }

  public get documentHeight(): number {
    const db = document.body as HTMLElement;
    const dde = document.documentElement as HTMLElement;
    return Math.max(db.scrollHeight, dde.scrollHeight, db.offsetHeight, dde.offsetHeight, db.clientHeight, dde.clientHeight);
  }

  public get perRotation(): number {
    return (3.6 * this.scrollPer) - 90;
  }

  public get largeIcons(): boolean {
    return this.$vuetify.breakpoint.smAndUp;
  }

  public get scrolled(): boolean {
    return !!this.scrollPosition;
  }

  public get title(): string {
    let t = 'Michael Minor';
    if (this.hasActivePersona) {
      t += `: ${this.currentPersona.title}`;
    }
    return t;
  }

  public get windowHeight(): number {
    return window.innerHeight;
  }

  @Watch('scrollPer')
  public onScrollPerChange(val: number, oldVal: number): void {
    TweenMax.to(this.$refs.progressBar, 0.2, {
      width: `${val}%`,
    });
  }

  public mounted(): void {
    this.checkScroll();
  }

  public checkScroll(e?: Event): void {
    const yPos: number = window.scrollY;
    this.scrollDirection = this.scrollPosition > yPos ? 'up' : 'down';
    this.scrollPosition = yPos;
    this.scrolledPast = this.scrollPosition > 100;
    this.scrollPer = Math.ceil(yPos / (this.documentHeight - this.windowHeight) * 100);
    // if (this.scrolledPast) {
    //   this.hideFilters();
    // }
  }

  public onFilterToggleClick(e: Event): void {
    this.toggleFilters();
  }

  public onResize = (e: Event) => this.checkScroll(e);

  public onScroll(e: Event): void {
    this.checkScroll(e);
  }
}
